const PORT = window.location.port === '3000' ? ':8082': ''
const BASE_URL = `${window.location.protocol}//${window.location.hostname}${PORT}`
const START = '/api/start';
const SPREADSHEET_START = '/api/spreadsheet/start';
export {
    BASE_URL,
    START,
    SPREADSHEET_START
}


// WEBPACK FOOTER //
// ./src/js/services/constants/urls.js